module.exports = __webpack_public_path__ + "static/media/techtrans.6598aaee.png";